import React from "react";
import { Box, Skeleton, Stack, useMediaQuery, useTheme } from "@mui/material";

export default function BlogPageSkeleton() {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        width: { xs: "340px", sm: "300px", md: "320px", xxl: "390px" },
        height: { xs: "auto", sm: "400px", md: "420px", xxl: "490px" },
        display: "flex",
        flexDirection: { xs: "row", sm: "column" }, // row on mobile, column on larger screens
        position: "relative",
        bgcolor: theme.palette.background.lightBlue,
        borderRadius: "10px",
        overflow: "hidden",
        gap: 1,
        p: { xs: "12px", sm: "16px" },
      }}
    >
      {/* Small overlay image */}
      <Box
        sx={{
          width: { xs: "35px", md: "55px" },
          height: { xs: "35px", md: "55px" },
          position: "absolute",
          top: isMobile ? "75%" : "45%",
          right: isMobile ? "3%" : "0",
        }}
      >
        <Skeleton variant="circular" width="100%" height="100%" />
      </Box>

      {/* Main image */}
      <Box
        sx={{
          flex: { xs: "0 0 40%", sm: "unset" },
          height: { xs: "150px", sm: "220px", md: "250px" },
          mr: { xs: "12px", sm: "0" },
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ borderRadius: "8px" }}
        />
      </Box>

      {/* Content */}
      <Stack
        sx={{
          flex: 1,
          justifyContent: "space-evenly",
          mt: { xs: 0, sm: "1rem" },
        }}
      >
        <Stack sx={{ px: { xs: 0, sm: "16px" } }}>
          {/* Title */}
          <Skeleton variant="text" width="70%" height={30} />
          {/* Description */}
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="90%" height={20} />
        </Stack>

        {/* Button */}
        <Skeleton
          variant="rectangular"
          width="80%"
          height={40}
          sx={{
            mx: { xs: 0, sm: "20px" },
            borderRadius: "6px",
            alignSelf: { xs: "flex-start", sm: "center" },
          }}
        />
      </Stack>
    </Box>
  );
}
